import * as React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import Headerbar from "./components/Headerbar/Headerbar";
import { logout } from "../../auth/logout";

import { NavStructurePropTypes, ToolbarItemsPropTypes } from "./vars";
import { SecurityBreachBanner } from "../Banner";

function appendLogoutToNav(navStructure: any) {
  const logoutMenuItem = {
    desktopOnly: true,
    label: "Log out",
    icon: "logout",
    onClick: function() {
      logout();
    }
  };

  const lasNavMenu = navStructure[navStructure.length - 1];
  return [
    ...navStructure.slice(0, navStructure.length - 1),
    {
      ...lasNavMenu,
      menuItems: [...lasNavMenu.menuItems, logoutMenuItem]
    }
  ];
}

const AuthNavWrapper = styled.div`
  background-color: ${p => p.theme.colors.white};
`;

export class MyAccountHeaderBarContainer extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes,
    ...ToolbarItemsPropTypes,
    logoutUrl: PropTypes.string,
    customerCode: PropTypes.string
  };

  render() {
    const { logoutUrl, navStructure, toolbarItems, customerCode } = this.props;

    const navStructureWithLogoutMenuItem = appendLogoutToNav(navStructure);

    return (
      <AuthNavWrapper
        data-id="auth-navbar-wrapper"
        data-customer-code={customerCode}
      >
        <SecurityBreachBanner />
        <Headerbar
          navStructure={navStructureWithLogoutMenuItem}
          className="style--rebrand"
          toolbarItems={toolbarItems}
          logoutUrl={logoutUrl}
        />
      </AuthNavWrapper>
    );
  }
}
